export const iconFontAwesomeHouseholdMattressPillow = (
	<i className="fa-solid fa-mattress-pillow"></i>
);
